import { convertToTimeZone } from "date-fns-timezone";
import { intervalToDuration } from "date-fns";
import { getEffectiveDue } from "./get-effective-due";

const getPrefix = (isOverdue) => (isOverdue ? "-" : "");

export const getFormattedDuration = (targetDate) => {
    const utcDate = getEffectiveDue(
        convertToTimeZone(targetDate, {
            timeZone: "America/Chicago",
        })
    );
    const isOverdue =
        convertToTimeZone(new Date(), {
            timeZone: "America/Chicago",
        }) > utcDate;
    const duration = intervalToDuration({
        start: convertToTimeZone(new Date(), {
            timeZone: "America/Chicago",
        }),
        end: utcDate,
    });

    const { years, months, days, hours, minutes } = duration;

    if (years) {
        return `${getPrefix(isOverdue)}${years} year(s)${hours !== 0 ? `, ${months} month(s)` : ""}`;
    }

    if (months) {
        return `${getPrefix(isOverdue)}${months} month(s)${hours !== 0 ? `, ${days} day(s)` : ""}`;
    }

    if (days) {
        return `${getPrefix(isOverdue)}${days} day(s)${hours !== 0 ? `, ${hours} hour(s)` : ""}`;
    }

    if (hours) {
        return `${getPrefix(isOverdue)}${hours} hour(s)${minutes !== 0 ? `, ${minutes} minute(s)` : ""}`;
    }

    return `${getPrefix(isOverdue && minutes !== 0)}${minutes} minute(s)`;
};
